const screensConfig = {
  dsk: "1024px",
};

export default screensConfig;
